<template>
    <div>
        <loading-block v-if="dataIsLoading"></loading-block>
        <section v-else>
            <info-message v-if="displayMessage" :status="status">{{message}}
            </info-message>
            <div class="content">
                <div>
                    <h1>Administrateurs</h1>
                    <!--                    <uni-button>Créer un administrateur</uni-button>-->
                    <uni-button @click.native="showSectionAddAdmin = true">Créer un administrateur</uni-button>
                </div>

                <div>
                    <admin-inline v-for="user in users" :user="user"
                                  :family="families.find(el => el.id === user.family_id)"></admin-inline>
                </div>
            </div>
        </section>
        <pop-from-bottom :open="showSectionAddAdmin"
                         title="Ajout d'un administrateur"
                         @close="showSectionAddAdmin = false"
        >
            <template slot="content">
                <ValidationObserver ref="addRespObserver"
                                    v-slot="{ invalid }"
                                    tag="form"
                                    @submit.prevent="submitANewAdmin()"
                >

                    <uni-input-container label="Adresse e-mail" for="email">

                        <uni-input rules="required|email"
                                   v-model="newAdmin.email"
                                   id="email"
                        />
                    </uni-input-container>
                    <uni-input-container label="Nom" for="name">

                        <uni-input rules="required"
                                   v-model="newAdmin.name"
                                   id="name"
                        />
                    </uni-input-container>
                    <uni-input-container label="Prénom" for="firstname">

                        <uni-input rules="required"
                                   v-model="newAdmin.firstname"
                                   id="firstname"
                        />
                    </uni-input-container>
                    <div class="grid">
                        <uni-input-container label="Rôle de l'administrateur">

                            <uni-input-radio v-for="role in authorizations" :label="role.label"
                                             :id="role.name+'AdminRadioButton'" style="margin-top:12px">
                                <input type="radio" v-model="adminRole" :id="role.name+'AdminRadioButton'"
                                       :value="role.name">

                            </uni-input-radio>

                        </uni-input-container>
                        <div class="roles">
                            <div v-for="role in roles" v-html="role.description" :class="{'not': role.disable}">

                            </div>
                        </div>
                    </div>

                    <uni-button @click.native="createNewAdmin">Ajouter l'administrateur</uni-button>
                </ValidationObserver>
            </template>
        </pop-from-bottom>
    </div>
</template>

<script>
    import LoadingBlock from "../../components/c-blocks/LoadingBlock";
    import UserInline from "../../components/b-patterns/userInline";
    import UniButton from "../../components/a-elements/UniButton";
    import PopFromBottom from "../../components/c-blocks/PopFromBottom";
    import UniInputContainer from "../../components/a-elements/UniInputContainer";
    import UniInput from "../../components/a-elements/UniInput";
    import InputBirthday from "../../components/a-elements/InputBirthday";
    import RichYesNoInput from "../../components/a-elements/RichYesNoInput";
    import UniInputRadio from "../../components/a-elements/UniInputRadio";
    import DuoInput from "../../components/b-patterns/DuoInput";
    import AdminInline from "../../components/b-patterns/adminInline";
    import InfoMessage from "../../components/a-elements/InfoMessage";

    export default {
        name: "adminAdministrators",
        components: {
            InfoMessage,
            AdminInline,
            DuoInput,
            UniInputRadio,
            RichYesNoInput,
            InputBirthday, UniInput, UniInputContainer, PopFromBottom, UniButton, UserInline, LoadingBlock
        },
        watch: {
            adminRole(val) {
                this.changeRoles(val)
            }
        },
        data() {
            return {
                displayMessage: false,
                status: 'success',
                message: '',
                users: [],
                families: [],
                dataIsLoading: false,
                showSectionAddAdmin: false,
                adminRole: '',
                newAdmin: {
                    email: "",
                    is_dancer: false,
                    name: '',
                    firstname: '',
                },
                roles: [
                    {
                        id: 1,
                        description: "Gérer les admins, les profs, les cours et les options",
                        disable: true
                    },
                    {
                        id: 2,
                        description: "Consulter les informations d'une famille / d'un danseur",
                        disable: true
                    },
                    {
                        id: 3,
                        description: "Modifier les informations d'une famille / d'un danseur",
                        disable: true
                    },
                    {
                        id: 4,
                        description: "Liste d'appel des élèves (à venir)",
                        disable: true
                    },
                    {
                        id: 5,
                        description: "Trier les danseurs et exporter les données",
                        disable: true
                    }
                ],
                authorizations: [
                    {
                        label: 'Admin',
                        name: 'admin',
                        roles: [1, 2, 3, 5]
                    },
                    {
                        label: 'Éditeur',
                        name: 'payment',
                        roles: [2, 3, 5]
                    },
                    {
                        label: 'Lecteur',
                        name: 'consult',
                        roles: [2, 5]
                    },
                    {
                        label: 'Professeur',
                        name: 'prof',
                        roles: [2, 4, 5]
                    }
                ]
            }
        },
        methods: {
            submitANewAdmin() {
                // Add the magic sauce here
            },
            changeRoles(val) {
                let tab = this.authorizations.find(el => el.name === val).roles;
                this.roles.forEach(el => el.disable = !tab.includes(el.id));
            },
            createNewAdmin() {
                this.showSectionAddAdmin = false
                let pw = Math.random().toString(36).slice(-8)
                let obj = {
                    users_attributes: {
                        0: {
                            ...this.newAdmin,
                        }
                    }
                }
                let family = {
                    email: this.newAdmin.email,
                    password: pw,
                    password_confirmation: pw,
                    is_admin: true,
                    role: this.adminRole,
                    ...obj
                }
                this.$http.post('/admin/admins', {family}, this.$getHeaders())
                    .then(response => {
                        this.message = "Un e-mail a été envoyé à la personne pour qu'elle finisse de compléter ses\n" +
                            "                informations personnelles"
                        this.status = "success"
                        this.displayMessage = true
                        window.setTimeout(() => {
                            this.displayMessage = false
                        }, 3000)

                    })
                    .catch(err => {
                        if (this.$isSignatureExpired(err.response.data.message)) {
                            this.$store.dispatch('logout')
                            this.$router.push({name: 'Login', params: {q: 'expired'}})
                        }
                    })

            }
        },
        async created() {
            // this.$adminGetDancers()
            //     .then(data => {
            //         this.users = data
            //         this.dataIsLoading = false
            //     })
            let response = await this.axios.get('/admin/admins')

            this.families = response.data

            response.data.forEach(el => {
                this.users.push(el.users[0])
            })

            this.users = this.users.sort(this.$dynamicSort('name'))

        }
    }
</script>

<style scoped lang="scss">

    .content {
        > div:first-child {
            margin-bottom: 1rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }

    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    .roles {
        > div {
            margin-bottom: 1rem;
            position: relative;

            &:before {
                position: absolute;
                content: "\002705";
                left: -24px;
            }

            &.not {
                color: var(--color-grey-light-1);

                &:before {
                    content: ""
                }
            }
        }

    }

</style>
